export default __webpack_public_path__ + "static/media/technology1.e2384544.0d54c281.jpg";